import { BookingCalendarInterface } from 'common/types/entities/BookingCalendarInterface'
import { FontProps } from 'common/utils/styleUtilsNew'
import React from 'react'
import {
  AvailabilitySlot,
  BookingInterface,
  EventInterface,
  EventLocationInterface,
} from '../calendar-interface'
import { DayPicker } from './day-picker'
import { EventInfo } from './event-info'
import { TimeSlots } from './time-slots'
import { CommonCalendarUi } from './ui/common-calendar-ui'

export interface CalendarStepProps {
  entity: BookingCalendarInterface
  availabilitySlots: AvailabilitySlot[]
  selectedDate?: Date
  onDateSelect?: (date: Date) => void
  selectedTimeSlot?: number
  onTimeSlotSelect?: (timeSlot: number) => void
  selectedTimeZone: string
  onTimeZoneSelect?: (timeZone: string) => void
  selectedMonth?: Date
  onMonthSelect?: (month: Date) => void
  selectedLocationId?: EventLocationInterface['id']
  onLocationSelect?: (locationId: EventLocationInterface['id']) => void
  onNextStepClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void

  event?: EventInterface
  booking?: BookingInterface
  isLoading?: boolean
  isMobile?: boolean
}

export const CalendarStep = ({
  availabilitySlots,
  selectedDate,
  selectedMonth,
  onMonthSelect,
  onDateSelect,
  selectedTimeSlot,
  onTimeSlotSelect,
  selectedTimeZone,
  onTimeZoneSelect,
  selectedLocationId,
  onLocationSelect,
  event,
  booking,
  isLoading,
  entity,
  isMobile,
}: Omit<CalendarStepProps, 'entity'> & {
  entity: Omit<BookingCalendarInterface, 'questions'>
} & FontProps) => {
  return (
    <CommonCalendarUi>
      <EventInfo
        {...event}
        selectedTimeZone={selectedTimeZone}
        onTimeZoneSelect={onTimeZoneSelect}
        titlesColor={entity.titlesColor}
        mobileTitlesColor={entity.mobileTitlesColor}
        color={entity.color}
        mobileColor={entity.mobileColor}
        selectedSlotBackgroundColor={entity.selectedSlotBackgroundColor}
        selectedLocationId={selectedLocationId}
        onLocationSelect={onLocationSelect}
        isLoading={isLoading}
        booking={booking}
        timeFormat={entity.timeFormat}
        isMobile={isMobile}
      />
      <DayPicker
        selectedDate={selectedDate}
        onDateSelect={onDateSelect}
        selectedMonth={selectedMonth}
        onMonthSelect={onMonthSelect}
        isLoading={isLoading}
        availableSlotBackgroundColor={entity.availableSlotBackgroundColor}
        selectedSlotBackgroundColor={entity.selectedSlotBackgroundColor}
        color={entity.color}
        mobileColor={entity.mobileColor}
        titlesColor={entity.titlesColor}
        mobileTitlesColor={entity.mobileTitlesColor}
        availabilitySlots={availabilitySlots}
        displayTimezone={event?.displayTimezone}
        isMobile={isMobile}
      />
      {selectedDate && (
        <TimeSlots
          availabilitySlots={availabilitySlots}
          onTimeSlotSelect={onTimeSlotSelect}
          selectedTimeSlot={selectedTimeSlot}
          selectedSlotBackgroundColor={entity.selectedSlotBackgroundColor}
          selectedDate={selectedDate}
          titlesColor={entity.titlesColor}
          timeFormat={entity.timeFormat}
          eventType={event?.eventType ?? 'INDIVIDUAL'}
        />
      )}
    </CommonCalendarUi>
  )
}
